var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPropostaValorMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 104,
    viewBox: "0 0 344 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_28738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1216 102C1216 102 296.758 102 195.5 102H178C175.791 102 174 98.7049 174 96.4958V87.129C174 85.2073 172.627 83.4229 170.706 83.1484L149.979 79.7169L137.9 72.1675C135.292 70.5203 132.41 69.6968 129.39 69.6968H125.101M0 102H27.6603C31.6603 102 31.6603 98.7049 31.6603 96.4958V89.5815H26.1693V79.9671L67.1803 49.7505L78.1624 56.6179M56.1991 102V89.5815H75.4178V102M115.854 101.995V45.1414L135.258 26.6859C139.57 21.8923 139.81 14.7018 135.737 9.66846L112.98 30.2811C111.303 32.1986 107.47 32.9176 104.835 32.9176H98.8458C96.2107 32.9176 92.6174 31.9589 90.9405 30.2811L67.4641 9.66846C63.3916 14.7018 63.6312 21.8923 68.1828 26.6859L88.3054 45.1414V101.995M101.961 65.9946V101.996M125.101 97.58H146.959M125.101 79.853H149.979M101.935 24.4354C95.0997 24.4354 89.2772 19.3302 89.2772 12.8327C89.2772 6.56724 94.8465 1.22998 101.935 1.22998C108.77 1.22998 114.592 6.33519 114.592 12.8327C114.592 19.0982 109.023 24.4354 101.935 24.4354ZM166.038 97.28C166.038 100.616 163.334 103.32 159.999 103.32C156.663 103.32 153.959 100.616 153.959 97.28C153.959 93.9445 156.663 91.24 159.999 91.24C163.334 91.24 166.038 93.9445 166.038 97.28Z",
    stroke: "#D70064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_28738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 344,
    height: 104,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPropostaValorMobile);
export default __webpack_public_path__ + "static/media/icon-proposta-valor-mobile.46241afb.svg";
export { ForwardRef as ReactComponent };